import { z } from 'zod';
import { messageKey } from './messages.js';
import { emailSchema } from './auth.js';
import { permissionSchema } from './permissions.js';
export const roleSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    permissions: z.array(permissionSchema),
    /** Системная роль общая для всех организаций и не редактируется. */
    isSystem: z.boolean(),
});
export const userSchema = z.object({
    id: z.uuid(),
    orgId: z.uuid(),
    email: z.string(),
    displayName: z.string(),
    isActive: z.boolean(),
    mustChangePassword: z.boolean(),
    lastLoginAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
    roles: z.array(z.object({ id: z.uuid(), name: z.string() })),
});
/**
 * Приглашение пользователя (ТЗ §11, фаза 1, задача 4).
 *
 * Пароль не задаётся приглашающим: сервер генерирует временный и возвращает
 * его один раз в ответе. Так пароль не проходит через форму, не попадает
 * в историю браузера администратора и обязателен к смене при первом входе.
 */
export const inviteUserSchema = z.object({
    email: emailSchema,
    displayName: z.string().trim().min(1).max(200),
    roleIds: z.array(z.uuid()).min(1, messageKey('validation.user.roleRequired')),
});
export const inviteUserResponseSchema = z.object({
    user: userSchema,
    /** Показывается один раз и нигде не хранится в открытом виде. */
    temporaryPassword: z.string(),
});
/**
 * Сброс пароля администратором (раздел «Пользователи»).
 *
 * Ответ той же формы, что и у приглашения, и по той же причине: сервер
 * придумывает пароль сам и показывает его один раз. Администратор не
 * выбирает пароль за человека — иначе он его знает, а «знает» и «может
 * восстановить доступ» это разные права.
 */
export const resetPasswordResponseSchema = z.object({
    user: userSchema,
    /** Показывается один раз и нигде не хранится в открытом виде. */
    temporaryPassword: z.string(),
});
export const updateUserSchema = z
    .object({
    displayName: z.string().trim().min(1).max(200),
    isActive: z.boolean(),
    roleIds: z.array(z.uuid()).min(1),
})
    .partial();
//# sourceMappingURL=users.js.map